import * as access from "../js/functions.js";
const {changeAnParcele, getParcele} = access;

//DOM Ready
$(document).ready(function(){
	
	console.log('READY');
	
	//get all parcele data from database
	getParcele();
	
	//select drop change trigger (year)
	$('#parcels_year_select').on('change', function() {
		changeAnParcele();
	});				
	
		
		
});